// notification.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PopupService } from 'src/app/modules/shared/_components/pricing-popup/popup.service';

export interface Notification {
    message: string;
    type?: 'success' | 'info' | 'warning' | 'error';
    duration?: number;
    action?: string; // e.g. 'View Plans'
    actionCallback?: () => void;
}

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private notificationSubject = new Subject<Notification>();
    notifications$ = this.notificationSubject.asObservable();

    constructor(private popupService: PopupService) {
    }


    show(notification: Notification): void {
        this.notificationSubject.next(notification);
    }

    showPlanAndTrialMessage(plan: 'none' | 'basic' | 'standard' | 'advance', daysLeft: number): void {
        if (plan === 'none') {
          this.showPlanMessage('none');
        } else if (plan === 'basic') {
          this.showPlanMessage('basic');
        } else if (plan === 'advance' && daysLeft <= 3 && daysLeft > 0) {
          this.showTrialEnding(daysLeft);
        }
      }

    showPlanMessage(plan: 'none' | 'basic' | 'standard' | 'advance') {
        switch (plan) {
            case 'none':
                this.show({ message: 'Please subscribe to a plan to view tenders.', type: 'warning', action: 'View Plans', actionCallback: () => this.popupService.openPricingPopup() });
                break;
            case 'basic':
                this.show({ message: 'Upgrade to Standard or Advance plan to view tender details.', type: 'info' });
                break;
        }
    }

    showTrialEnding(daysLeft: number): void {
        this.show({
            message: `Your trial ends in ${daysLeft} day(s). Consider upgrading your plan.`,
            type: 'info',
        });
    }
}
